import { useMemo, useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { MsalProvider } from '@azure/msal-react';
import { getMsalInstance, getMsalInitializationPromise } from './utils/msalInstance';
import { ApiProvider } from './contexts/ApiContext';
import { PermissionProvider } from './contexts/PermissionContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import AppShell from './components/AppShell/AppShell';
import LoginPage from './pages/Login/LoginPage';
import HomePage from './pages/Home/HomePage';
import HistoryPage from './pages/History/HistoryPage';
import EducationPage from './pages/Education/EducationPage';
import LogsPage from './pages/Logs/LogsPage';
import DlqPage from './pages/DLQ/DlqPage';
import { TrackingPage } from './pages/Tracking/TrackingPage';
import { SectionTrackingPage } from './pages/Tracking/SectionTrackingPage';
import AlertsPage from './pages/Alerts/AlertsPage';
import MaintenancePage from './pages/Maintenance/MaintenancePage';
import AccessControlPage from './pages/AccessControl/AccessControlPage';
import AboutPage from './pages/About/AboutPage';

function App() {
  const instance = useMemo(() => getMsalInstance(), []);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initPromise = getMsalInitializationPromise();
    if (initPromise) {
      initPromise.then(() => setIsInitialized(true)).catch(() => setIsInitialized(true));
    } else {
      setIsInitialized(true);
    }
  }, []);

  // Aguarda inicializacao do MSAL antes de renderizar
  if (!isInitialized) {
    return null;
  }

  return (
    <MsalProvider instance={instance}>
      <ApiProvider>
        <PermissionProvider>
          <FluentProvider theme={webLightTheme}>
            <BrowserRouter>
              <Routes>
                {/* Public route - Login */}
                <Route path="/login" element={<LoginPage />} />

                {/* Protected routes - Main application */}
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <AppShell />
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<HomePage />} />
                  <Route path="history" element={<HistoryPage />} />
                  <Route path="education" element={<EducationPage />} />
                  <Route path="tracking" element={<TrackingPage />} />
                  <Route path="section-tracking" element={<SectionTrackingPage />} />
                  <Route path="logs" element={<LogsPage />} />
                  <Route path="dlq" element={<DlqPage />} />
                  <Route path="alerts" element={<AlertsPage />} />
                  <Route path="maintenance" element={<MaintenancePage />} />
                  <Route path="access-control" element={<AccessControlPage />} />
                  <Route path="about" element={<AboutPage />} />
                </Route>
              </Routes>
            </BrowserRouter>
          </FluentProvider>
        </PermissionProvider>
      </ApiProvider>
    </MsalProvider>
  );
}

export default App;
